<template>
	<section class="page">
		<el-tabs v-model="activeName">
			<el-tab-pane label="库存" name="list">
				<div class="content-box">
					<div class="operator">
						<div class="operator-col">
							<hispickup v-model="filterHisDate" size="mini"></hispickup>
						</div>
						<div class="operator-col">
							<el-input
								size="mini"
								v-model="filterTableSearch"
								placeholder="商品名"
								suffix-icon="el-icon-search"
								clearable
							></el-input>
						</div>
					</div>
					<curd-table
						:has-delete="false"
						ref="listTable"
						:data-model="editorDataModel"
						:fields="tableFields"
						@doedit="handleEdit($event)"
						:kv-filter="kvFilter"
            :search-filter="filterTableSearch"
					>
						<template slot="listOp" slot-scope="scope">
							<el-button size="mini" type="text" @click="goTxInfo(scope.row._id)">详情</el-button>
						</template>
					</curd-table>
				</div>
			</el-tab-pane>
		</el-tabs>
	</section>
</template>

<script>
import CurdPage from "@/mixins/CurdPage.js";
import Filters from "@/mixins/Filters.js";

export default {
	mixins: [CurdPage, Filters],
	data() {
		return {
			editorDataModel: "Transaction",
			tableFields: [
				{
					name: "show_id",
					sortable: "custom"
				},
				{
					name: "type",
					sortable: true
				},
				{
					name: "name",
					isTrans: false,
					sortable: false
				},
				{
					name: "warehouse",
					isTrans: true,
					sortable: "custom",
					isTag: true
				},
				{
					name: "total_price",
					isTrans: false,
					sortable: false
				},
				{
					name: "status",
					isTrans: false,
					sortable: false
				},
				{
					name: "created_user",
					isTrans: false,
					sortable: false
				},
				{
					name: "tx_at",
					isTrans: false,
					sortable: false
				}
			],
			editorFields: [
				{
					name: "name",
					rules: ["required"]
				}
			],
			baseKv: [{ k: "status", t: "int", lge: "==", v: 30 }]
		};
	},
	methods: {
		goTxInfo(id) {
			this.$router.push({
				name: "Tx-Info",
				params: {
					id: id,
					tab: "info"
				}
			});
		}
	}
};
</script>
<style lang="scss" scoped>
</style>
